var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFinanceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.57897 8.07897C11.2124 8.07897 14.1579 6.60622 14.1579 4.78948C14.1579 2.97275 11.2124 1.5 7.57897 1.5C3.9455 1.5 1 2.97275 1 4.78948C1 6.60622 3.9455 8.07897 7.57897 8.07897Z",
    stroke: "#999999",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 4.78943V9.39471C1 11.2112 3.9454 12.6842 7.57897 12.6842C11.2125 12.6842 14.1579 11.2112 14.1579 9.39471V4.78943",
    stroke: "#999999",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 9.39465V13.9999C1 15.8164 3.9454 17.2894 7.57897 17.2894C11.2125 17.2894 14.1579 15.8164 14.1579 13.9999V9.39465",
    stroke: "#999999",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1 14V18.6053C1 20.4217 3.9454 21.8948 7.57897 21.8948C11.2125 21.8948 14.1579 20.4217 14.1579 18.6053V14",
    stroke: "#999999",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1 18.6052V23.2105C1 25.027 3.9454 26.5 7.57897 26.5C11.2125 26.5 14.1579 25.027 14.1579 23.2105V18.6052",
    stroke: "#999999",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7369 17.2894C24.3704 17.2894 27.3159 15.8167 27.3159 13.9999C27.3159 12.1832 24.3704 10.7104 20.7369 10.7104C17.1035 10.7104 14.158 12.1832 14.158 13.9999C14.158 15.8167 17.1035 17.2894 20.7369 17.2894Z",
    stroke: "#999999",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.158 14V18.6053C14.158 20.4217 17.1034 21.8948 20.7369 21.8948C24.3705 21.8948 27.3159 20.4217 27.3159 18.6053V14",
    stroke: "#999999",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.158 18.6052V23.2105C14.158 25.027 17.1034 26.5 20.7369 26.5C24.3705 26.5 27.3159 25.027 27.3159 23.2105V18.6052",
    stroke: "#999999",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinanceIcon);
export default __webpack_public_path__ + "static/media/financeIcon.2f8e8d3531430c4e17568f6316ff66f9.svg";
export { ForwardRef as ReactComponent };